import { z } from 'zod';
import { DOCUMENT_TYPES, DOCUMENT_VISIBILITIES } from '../enums.js';
import { optionalText, text, uuidSchema } from './common.js';
export const documentTypeSchema = z.enum(DOCUMENT_TYPES);
export const documentVisibilitySchema = z.enum(DOCUMENT_VISIBILITIES);
/** 25 MB. Inspection photo sets are the driver; lease PDFs are far smaller. */
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const ALLOWED_UPLOAD_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/heic',
];
/**
 * Step one of an upload: the client asks for a presigned PUT. The server
 * authorizes against the parent record *before* issuing the URL and chooses the
 * storage key itself — a client-supplied key is a path traversal waiting to
 * happen. Files never touch the VPS disk.
 */
export const requestUploadSchema = z
    .object({
    documentType: documentTypeSchema,
    visibility: documentVisibilitySchema.default('STAFF_ONLY'),
    fileName: text(255),
    contentType: z.enum(ALLOWED_UPLOAD_MIME_TYPES),
    sizeBytes: z.coerce.number().int().min(1).max(MAX_UPLOAD_BYTES),
    /** Exactly one parent. Which one it is decides who can see the document. */
    propertyId: uuidSchema.nullish(),
    unitId: uuidSchema.nullish(),
    leaseId: uuidSchema.nullish(),
    tenantId: uuidSchema.nullish(),
    description: optionalText(500),
})
    .refine((v) => [v.propertyId, v.unitId, v.leaseId, v.tenantId].filter(Boolean).length === 1, 'A document must attach to exactly one of property, unit, lease, or tenant.');
/** Step two: the client confirms the PUT succeeded so the row becomes visible. */
export const finalizeUploadSchema = z.object({
    documentId: uuidSchema,
    /** S3 ETag, used to detect a truncated or swapped upload. */
    etag: optionalText(128),
});
//# sourceMappingURL=document.js.map